import React from 'react'
import LoadingSvg from '../../../../../img/loading.svg';

/**
 * 
 * @param {string} [loadText] - Text to display during loading animation
 * @param {boolean} [small] -  Display a smaller version of the loader
 * @param {boolean} [paused] -  Stop the animation from playing - this is useful when using the loader as a "skeleton" while waiting for a component to load in
 */
function LoadingPanel({loadText, small, paused = false}) {

    /**
     * Appends dots after load text
     * @returns {string}
     */
    const getLoadText = () => {
        let retText = '';
        if(loadText){
            retText = loadText + '...';
        }
        return (
            retText
        )
    }
    
    // Component level JSX return statement ******************************************************
    return (
        <div className={`panel-loading ${small ? ' panel-loading--small': ''} ${paused ? ' pause-animation' : ''}`}><LoadingSvg/> {getLoadText()}</div>
    )
}
export default LoadingPanel;